export default [
  'loan',
  'saving',
  'social_fund',
  'individual_micro_loan',
];
